import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BreadcrumbLink } from '@ajgre/toolkit';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 're-breadcrumb',
  imports: [RouterLink],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss'
})
export class BreadcrumbComponent {
  @Input() links!: BreadcrumbLink[];
}
